/* istanbul ignore file */
import React from 'react';
import { AlertBanner, Exclamation, ExclamationCircle, InformationCircle } from 'ui';
import { BROADCAST_MESSAGE_TYPE } from 'utils/constants';

interface IBroadcastBanner {
  message: string;
  action?: {
    label: string | React.ReactNode;
    onClick: () => void;
  };
  type: BROADCAST_MESSAGE_TYPE;
  closeButtonOnClick: () => void;
}

type Variant = 'neutral' | 'informational' | 'error' | 'warning';

const variants: Record<BROADCAST_MESSAGE_TYPE, Variant> = {
  [BROADCAST_MESSAGE_TYPE.ALERT]: 'error',
  [BROADCAST_MESSAGE_TYPE.WARNING]: 'warning',
  [BROADCAST_MESSAGE_TYPE.INFO]: 'informational',
  [BROADCAST_MESSAGE_TYPE.NEUTRAL]: 'neutral',
};

const icons: Record<BROADCAST_MESSAGE_TYPE, React.ReactNode> = {
  [BROADCAST_MESSAGE_TYPE.ALERT]: <ExclamationCircle />,
  [BROADCAST_MESSAGE_TYPE.WARNING]: <Exclamation />,
  [BROADCAST_MESSAGE_TYPE.INFO]: <InformationCircle />,
  [BROADCAST_MESSAGE_TYPE.NEUTRAL]: null,
};

export const BroadcastBanner: React.FC<IBroadcastBanner> = ({ message, action, type, closeButtonOnClick }) => (
  <AlertBanner
    variant={variants[type]}
    icon={icons[type]}
    message={message}
    action={action}
    dismissable={type !== BROADCAST_MESSAGE_TYPE.ALERT}
    closeButtonOnClick={closeButtonOnClick}
  />
);
